import { objectSpread2 as _objectSpread2 } from '../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useContext, createContext } from 'react';
import { anchorVariants } from '../components/anchor/anchor.variants.esm.js';
import { bannerVariants } from '../components/banner/banner.variants.esm.js';
import { buttonVariants } from '../components/button/button.variants.esm.js';
import { cardVariants } from '../components/card/card.variants.esm.js';
import { dividerVariants } from '../components/divider/divider.variants.esm.js';
import { tagInnerVariants } from '../components/tag/tag-inner.variants.esm.js';
import { textVariants } from '../components/text/text.variants.esm.js';
import { toastVariants } from '../components/toast-content/toast.variants.esm.js';
import { headingVariants } from '../components/text/heading.variants.esm.js';
import { avatarStyles } from '../components/avatar/avatar.styles.esm.js';

var defaultVariant = {
  components: {
    Anchor: anchorVariants,
    Avatar: avatarStyles,
    Banner: bannerVariants,
    Button: buttonVariants,
    Card: cardVariants,
    Divider: dividerVariants,
    TagInner: tagInnerVariants,
    Text: _objectSpread2(_objectSpread2({}, textVariants), headingVariants),
    Toast: toastVariants
  }
};
var VariantContext = /*#__PURE__*/createContext({
  variant: defaultVariant
});
var VariantProvider = VariantContext.Provider;
function useVariant() {
  var _useContext;
  return ((_useContext = useContext(VariantContext)) === null || _useContext === void 0 ? void 0 : _useContext.variant) || defaultVariant;
}
function useComponentVariant(component, componentVariant) {
  var variant = useVariant();
  if (!componentVariant) {
    return {};
  }
  return variant.components[component][componentVariant];
}

export { VariantProvider, useComponentVariant, useVariant };
//# sourceMappingURL=variant.context.esm.js.map
